/**
 * StatCard — top-row KPI card in the CISO widget language.
 * Mono numeral, 3px colored top-bar, icon chip, description; whole card drills.
 */
export default function StatCard({
  label,
  value,
  icon,
  accent = "var(--rust-600)",
  valueColor = "var(--ink)",
  iconBg = "var(--cream)",
  iconColor = "var(--rust-600)",
  desc,
  onClick,
  testid,
}) {
  return (
    <div
      className="ciso-stat"
      data-testid={testid}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="ciso-stat__bar" style={{ background: accent }} />
      <div className="flex items-start justify-between gap-[14px]">
        <div className="min-w-0">
          <div
            className="text-[11px] font-bold ciso-cap"
            style={{ color: "var(--text-muted)" }}
          >
            {label}
          </div>
          <div
            className="ciso-num"
            style={{
              fontSize: 38,
              fontWeight: 600,
              letterSpacing: "-0.035em",
              lineHeight: 1,
              color: valueColor,
              marginTop: 13,
            }}
          >
            {value}
          </div>
        </div>
        {icon && (
          <span className="ciso-chip" style={{ background: iconBg, color: iconColor }}>
            <i className={icon} />
          </span>
        )}
      </div>
      {desc && (
        <p
          className="text-[12px]"
          style={{ margin: "14px 0 0", lineHeight: 1.5, color: "var(--text-secondary)" }}
        >
          {desc}
        </p>
      )}
    </div>
  );
}
